/** Libellés partagés des tâches d'arrière-plan et des présences en ligne. */

/** Nom lisible de chaque type de tâche (panneau flottant, page des tâches). */
export const TYPE_LABEL = {
  'client-intake': 'Analyse du lien',
  audit: 'Audit du site',
  proposal: 'Génération des variantes',
  pitch: 'Pitch commercial',
  quote: 'Devis',
  harvest: 'Exploration du site',
};

/** Type de présence en ligne, tel qu'affiché en pastille sur une carte. */
export const PRESENCE_LABEL = {
  website: 'Site web',
  facebook: 'Page Facebook',
  instagram: 'Compte Instagram',
  none: 'Sans site',
};

/**
 * La même présence, en nom commun pour une phrase (« seule vitrine : page
 * Facebook »). Absente quand le client a un site : c'est alors un audit, pas un
 * diagnostic, et la fiche client s'appuie sur ce vide pour choisir ses libellés.
 */
export const PRESENCE_NOUN = {
  facebook: 'page Facebook',
  instagram: 'compte Instagram',
};

/** Statuts d'une tâche qui n'a pas fini : le polling accélère tant qu'il en reste. */
export const ACTIVE_STATUSES = ['running', 'pending'];
